import React from 'react';

const FormBtnLarge = ({type, mStyle,disable=false, children}) => {
    return (
        <button type={type} className={`ipay-ui-btn__large ${mStyle} ${disable ? 'is--disable' : ''}`}>
           <span>{children}</span> 
        </button>
    );
};

export default FormBtnLarge;